export const WidgetSelectChannel = ({
    setIsChannels,
    currentDevice,
    lampStatus,
    setCurrentPVChannel,
    tempImages,
    selectedDevice,
    setPVSpecificChannel,
    pvSpecificChannel,
    tempTabIndexDevices,
    activeTabIndex,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    setTempTabIndexDevices,
    setUpdatedTabIndexDevices,
    multipleDevices,
    setMultipleDevices,
    tempTabIndexDisplay,
    setTempTabIndexDisplay,
    setUpdatedTabIndexDisplay,
    multipleDisplay,
    setMultipleDisplay,
    setCurrentPVController,
    setCurrentSVController,
    setPVControllerChannel,
    pvControllerChannel,
    setSVControllerChannel,
    svControllerChannel,
    tempTabIndexController,
    setTempTabIndexController,
    setUpdatedTabIndexController,
    multipleController,
    setMultipleController,
    tempTabIndexIO,
    setTempTabIndexIO,
    setUpdatedTabIndexIO,
    multipleIO,
    setMultipleIO,
    setCurrentPVFlowM,
    setCurrentSVFlowM,
    setPVFlowMChannels,
    pvFlowMChannels,
    setSVFlowMChannels,
    svFlowMChannels,
    tempTabIndexFlowM,
    setTempTabIndexFlowM,
    setUpdatedTabIndexFlowM,
    multipleFlowM,
    setMultipleFlowM,
    setCurrentPVEnergyM,
    setCurrentSVEnergyM,
    setPVEnergyMChannels,
    pvEnergyMChannels,
    setSVEnergyMChannels,
    svEnergyMChannels,
    tempTabIndexEnergyM,
    setTempTabIndexEnergyM,
    setUpdatedTabIndexEnergyM,
    multipleEnergyM,
    setMultipleEnergyM,
    tempTabIndexMotor,
    setTempTabIndexMotor,
    setUpdatedTabIndexMotor,
    multipleMotor,
    setMultipleMotor,
    tempTabIndexLineChart,
    lineChartChannels,
    setTempTabIndexLineChart,
    setUpdatedTabIndexLineChart,
    multipleLineCharts,
    setMultipleLineCharts,
    setLineChartChannels,
    tempTabIndexPieChart,
    pieChartChannels,
    setTempTabIndexPieChart,
    setUpdatedTabIndexPieChart,
    multiplePieChart,
    setMultiplePieChart,
    setPieChartChannels,
    tempTabIndexBarChart,
    barChartChannels,
    setTempTabIndexBarChart,
    setUpdatedTabIndexBarChart,
    multipleBarChart,
    setMultipleBarChart,
    setBarChartChannels,
    tempTabIndexHistogram,
    histogramChannels,
    setTempTabIndexHistogram,
    setUpdatedTabIndexHistogram,
    multipleHistogram,
    setMultipleHistogram,
    setHistogramChannels,
    setGaugeChannels,
    tempTabIndexGauge,
    gaugeChannels,
    setTempTabIndexGauge,
    setUpdatedTabIndexGauge,
    multipleGauge,
    setMultipleGauge,
    setProgressChannels,
    progressChannels,
    tempTabIndexProgress,
    setTempTabIndexProgress,
    setUpdatedTabIndexProgress,
    multipleProgress,
    setMultipleProgress,
    tempTabIndexTable,
    tableChannels,
    setTempTabIndexTable,
    setUpdatedTabIndexTable,
    multipleTable,
    setMultipleTable,
    setTableChannels,
    tempTabIndexCircularProgress,
    setTempTabIndexCircularProgress,
    setUpdatedTabIndexCircularProgress,
    multipleCircularProgress,
    setMultipleCircularProgress,
    tempTabIndexDoughnut,
    doughnutChannels,
    setTempTabIndexDoughnut,
    setUpdatedTabIndexDoughnut,
    multipleDoughnut,
    setMultipleDoughnut,
    setDoughnutChannels,
    sliderChannels,
    tempTabIndexSlider,
    setTempTabIndexSlider,
    setUpdatedTabIndexSlider,
    multipleSlider,
    setMultipleSlider,
    setSliderChannels,
    tempTabIndexLamp,
    setTempTabIndexLamp,
    setUpdatedTabIndexLamp,
    multipleLamp,
    setMultipleLamp,
    tempTabIndexSwitch,
    setTempTabIndexSwitch,
    setUpdatedTabIndexSwitch,
    multipleSwitch,
    setMultipleSwitch,
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,
    tempTabIndexText,
    setTempTabIndexText,
    setUpdatedTabIndexText,
    multipleText,
    setMultipleText,
    tempTabIndexPipe,
    setTempTabIndexPipe,
    setUpdatedTabIndexPipe,
    multiplePipe,
    setMultiplePipe,



}) => {
    setIsChannels(false);
    if (currentDevice === "Indicator") {

        const pvChannelValue = document.getElementById("pvChannels")?.value;
        setCurrentPVChannel(pvChannelValue);

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );
        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexDevices).length > 0) {
            const particularDevice = tempTabIndexDevices[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexDevices[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexDevices[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexDevices(newTempTabIndexDevices);
                                setUpdatedTabIndexDevices(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multipleDevices.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleDevices];
                const deviceToUpdate = multipleDevices.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                setMultipleDevices(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "Display") {
        const pvChannelValue = document.getElementById("pvChannels").value;
        setCurrentPVChannel(pvChannelValue);

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );
        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexDisplay).length > 0) {
            const particularDevice = tempTabIndexDisplay[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {
                    if (
                        tempTabIndexDisplay[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexDisplay[activeTabIndex]];

                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };

                                setTempTabIndexDisplay(newTempTabIndexDevices);
                                setUpdatedTabIndexDisplay(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multipleDisplay.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleDisplay];
                const deviceToUpdate = multipleDisplay.find(
                    (element, index) => index === clickedDeviceIndex
                );

                deviceToUpdate.pvChannel = pvChannelValue;
                setMultipleDisplay(updatedDeviceName);
            }
        }
    }


    if (currentDevice === "Controller") {
        const svChannelValue = document.getElementById("svChannels").value;
        const pvChannelValue = document.getElementById("pvChannels").value;
        setCurrentPVController(pvChannelValue);
        setCurrentSVController(svChannelValue);
        setPVControllerChannel(pvControllerChannel.concat(pvChannelValue));
        setSVControllerChannel(svControllerChannel.concat(svChannelValue));

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );


        if (Object.keys(tempTabIndexController).length > 0) {
            const particularDevice = tempTabIndexController[activeTabIndex];

            if (particularDevice !== undefined) {

                if (
                    tempTabIndexController[activeTabIndex].some(
                        (device) => device.id === selectedDevice.id
                    )
                ) {

                    if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                        let temporaryWidgets = [...tempImages];

                        const previousPV =
                            temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                        const previousSV =
                            temporaryWidgets[originalDeviceIndex]?.channelName?.SV;

                        const updatedData = {
                            ...temporaryWidgets[originalDeviceIndex],
                            channelName: {
                                ...temporaryWidgets[originalDeviceIndex].channelName,
                                PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                SV: svChannelValue !== null ? svChannelValue : previousSV,
                            },
                        };

                        temporaryWidgets[originalDeviceIndex] = updatedData;

                        setTempImages(temporaryWidgets);
                        setUpdatedImages(temporaryWidgets)
                        // storing new channel name to display data in main page

                        let oldtabIndexDevices = [
                            ...tempTabIndexController[activeTabIndex],
                        ];
                        const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                            (data) => data.id === selectedDevice.id
                        );

                        const newUpdatedData = {
                            ...oldtabIndexDevices[organizedDeviceIndex],
                            channelName: {
                                PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                SV: pvChannelValue !== null ? svChannelValue : previousSV,
                            },
                        };

                        oldtabIndexDevices[organizedDeviceIndex] = newUpdatedData;
                        const newTempTabIndexDevices = {
                            [activeTabIndex]: oldtabIndexDevices,
                        };

                        setTempTabIndexController(newTempTabIndexDevices);
                        setUpdatedTabIndexController(newTempTabIndexDevices);
                    }
                }
            }
        }
        if (multipleController.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleController;
                const deviceToUpdate = multipleController.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                deviceToUpdate.svChannel = svChannelValue;
                setMultipleController(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "DigitalIO") {
        const pvChannelValue = document.getElementById("pvChannels").value;
        const svChannelValue = document.getElementById("svChannels").value;



        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );
        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexIO).length > 0) {
            const particularDevice = tempTabIndexIO[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexIO[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const previousSV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    SV: svChannelValue !== null ? svChannelValue : previousSV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexIO[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                        SV: svChannelValue !== null ? svChannelValue : previousSV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexIO(newTempTabIndexDevices);
                                setUpdatedTabIndexIO(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }
        if (multipleIO.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleIO];
                const deviceToUpdate = multipleIO.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                deviceToUpdate.svChannel = svChannelValue;
                setMultipleIO(updatedDeviceName);
            }
        }
    }


    if (currentDevice === "FlowMeter") {
        const svChannelValue = document.getElementById("svChannels").value;
        const pvChannelValue = document.getElementById("pvChannels").value;
        setCurrentPVFlowM(pvChannelValue);
        setCurrentSVFlowM(svChannelValue);

        setPVFlowMChannels(pvFlowMChannels.concat(pvChannelValue));
        setSVFlowMChannels(svFlowMChannels.concat(svChannelValue));
        if (Object.keys(tempTabIndexFlowM).length > 0) {
            const particularDevice = tempTabIndexFlowM[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {

                    if (
                        tempTabIndexFlowM[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const previousSV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.SV;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    SV: svChannelValue !== null ? svChannelValue : previousSV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexFlowM[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            const newUpdatedData = {
                                ...oldtabIndexDevices[organizedDeviceIndex],
                                channelName: {
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    SV: pvChannelValue !== null ? svChannelValue : previousSV,
                                },
                            };
                            oldtabIndexDevices[organizedDeviceIndex] = newUpdatedData;

                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexDevices,
                            };
                            setTempTabIndexFlowM(newTempTabIndexDevices);
                            setUpdatedTabIndexFlowM(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleFlowM.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleFlowM;
                const deviceToUpdate = multipleFlowM.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                deviceToUpdate.svChannel = svChannelValue;
                setMultipleFlowM(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "EnergyMeter") {
        const svChannelValue = document.getElementById("svChannels").value;
        const svChannelValue2 = document.getElementById("svChannel2").value;
        const svChannelValue3 = document.getElementById("svChannel3").value;
        const pvChannelValue = document.getElementById("pvChannels").value;
        setCurrentPVEnergyM(pvChannelValue);
        setCurrentSVEnergyM(svChannelValue);
        setPVEnergyMChannels(pvEnergyMChannels.concat(pvChannelValue));
        setSVEnergyMChannels(svEnergyMChannels.concat(svChannelValue));
        if (Object.keys(tempTabIndexEnergyM).length > 0) {
            const particularDevice = tempTabIndexEnergyM[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {

                    if (
                        tempTabIndexEnergyM[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const previousSV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.SV;
                            const previousSV2 =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.SV2;
                            const previousSV3 =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.SV3;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    SV: svChannelValue !== null ? svChannelValue : previousSV,
                                    SV2: svChannelValue2 !== null ? svChannelValue2 : previousSV2,
                                    SV3: svChannelValue3 !== null ? svChannelValue3 : previousSV3,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexEnergyM[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            const newUpdatedData = {
                                ...oldtabIndexDevices[organizedDeviceIndex],
                                channelName: {
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    SV: svChannelValue !== null ? svChannelValue : previousSV,
                                    SV2: svChannelValue2 !== null ? svChannelValue2 : previousSV2,
                                    SV3: svChannelValue3 !== null ? svChannelValue3 : previousSV3,
                                },
                            };
                            oldtabIndexDevices[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexDevices,
                            };
                            setTempTabIndexEnergyM(newTempTabIndexDevices);
                            setUpdatedTabIndexEnergyM(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }
        if (multipleEnergyM.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleEnergyM;
                const deviceToUpdate = multipleEnergyM.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                deviceToUpdate.svChannel = svChannelValue;
                deviceToUpdate.svChannel2 = svChannelValue2;
                deviceToUpdate.svChannel3 = svChannelValue3;
                setMultipleEnergyM(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "Motor") {
        const pvChannelValue = document.getElementById("pvChannels").value;
        setCurrentPVChannel(pvChannelValue);

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );
        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexMotor).length > 0) {
            const particularDevice = tempTabIndexMotor[activeTabIndex];
            if (particularDevice !== undefined) {

                if (selectedDevice?.id) {
                    if (
                        tempTabIndexMotor[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexMotor[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexMotor(newTempTabIndexDevices);
                                setUpdatedTabIndexMotor(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multipleMotor.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleMotor];
                const deviceToUpdate = multipleMotor.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                setMultipleMotor(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "LineChart") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexLineChart).length > 0) {
            const particularDevice = tempTabIndexLineChart[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexLineChart[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? lineChartChannels : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);
                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexLineChart[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    lineChartChannels.length > 0
                                        ? lineChartChannels
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexLineChart(newTempTabIndexDevices);
                            setUpdatedTabIndexLineChart(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleLineCharts.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleLineCharts;
                const deviceToUpdate = multipleLineCharts.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = lineChartChannels;
                setMultipleLineCharts(updatedDeviceName);
            }
        }
        setLineChartChannels([]);
    }

    if (currentDevice === "PieChart") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexPieChart).length > 0) {
            const particularDevice = tempTabIndexPieChart[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexPieChart[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? pieChartChannels : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)

                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexPieChart[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    pieChartChannels.length > 0
                                        ? pieChartChannels
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexPieChart(newTempTabIndexDevices);
                            setUpdatedTabIndexPieChart(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multiplePieChart.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multiplePieChart;
                const deviceToUpdate = multiplePieChart.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = pieChartChannels;
                setMultiplePieChart(updatedDeviceName);
            }
        }
        setPieChartChannels([]);
    }

    if (currentDevice === "BarChart") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexBarChart).length > 0) {
            const particularDevice = tempTabIndexBarChart[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {
                    if (
                        tempTabIndexBarChart[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? barChartChannels : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);

                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexBarChart[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    barChartChannels.length > 0
                                        ? barChartChannels
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexBarChart(newTempTabIndexDevices);
                            setUpdatedTabIndexBarChart(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleBarChart.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleBarChart;
                const deviceToUpdate = multipleBarChart.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = barChartChannels;
                setMultipleBarChart(updatedDeviceName);
            }
        }
        setBarChartChannels([]);
    }

    if (currentDevice === "Histogram") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexHistogram).length > 0) {
            const particularDevice = tempTabIndexHistogram[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {

                    if (
                        tempTabIndexHistogram[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? histogramChannels : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);

                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexHistogram[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    histogramChannels.length > 0
                                        ? histogramChannels
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;

                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexHistogram(newTempTabIndexDevices);
                            setUpdatedTabIndexHistogram(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }
        if (multipleHistogram.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleHistogram;
                const deviceToUpdate = multipleHistogram.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = histogramChannels;
                setMultipleHistogram(updatedDeviceName);
            }
        }
        setHistogramChannels([]);
    }

    if (currentDevice === "Gauge") {
        const channelValue = document.getElementById("pvChannels").value;
        setGaugeChannels([channelValue]);
        if (Object.keys(tempTabIndexGauge).length > 0) {
            const particularDevice = tempTabIndexGauge[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexGauge[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? [channelValue] : previousChannels,
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page
                            let oldtabIndexGauge = [...tempTabIndexGauge[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexGauge.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            const newUpdatedData = {
                                ...oldtabIndexGauge[organizedDeviceIndex],
                                chartChannel: gaugeChannels ? [channelValue] : previousChannels,
                            };
                            oldtabIndexGauge[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexGauge,
                            };
                            setTempTabIndexGauge(newTempTabIndexDevices);
                            setUpdatedTabIndexGauge(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }
        if (multipleGauge.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleGauge;
                const deviceToUpdate = multipleGauge.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = [channelValue];
                setMultipleGauge(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "ProgressBar") {
        const channelValue = document.getElementById("pvChannels").value;
        setProgressChannels(progressChannels.concat(channelValue));
        if (Object.keys(tempTabIndexProgress).length > 0) {
            const particularDevice = tempTabIndexProgress[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexProgress[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? [channelValue] : previousChannels,
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page
                            let oldtabIndexProgressBar = [
                                ...tempTabIndexProgress[activeTabIndex],
                            ];
                            const organizedDeviceIndex = oldtabIndexProgressBar.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            const newUpdatedData = {
                                ...oldtabIndexProgressBar[organizedDeviceIndex],
                                chartChannel: progressChannels
                                    ? [channelValue]
                                    : previousChannels,
                            };
                            oldtabIndexProgressBar[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexProgressBar,
                            };
                            setTempTabIndexProgress(newTempTabIndexDevices);
                            setUpdatedTabIndexProgress(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleProgress.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleProgress;
                const deviceToUpdate = multipleProgress.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = [channelValue];
                setMultipleProgress(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "Table") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexTable).length > 0) {
            const particularDevice = tempTabIndexTable[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexTable[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? tableChannels : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page
                            let oldtabIndexTable = [...tempTabIndexTable[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexTable.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexTable[organizedDeviceIndex],
                                chartChannel:
                                    tableChannels.length > 0 ? tableChannels : previousChannels,
                            };

                            oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexTable,
                            };
                            setTempTabIndexTable(newTempTabIndexDevices);
                            setUpdatedTabIndexTable(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleTable.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleTable;
                const deviceToUpdate = multipleTable.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = tableChannels;
                setMultipleTable(updatedDeviceName);
            }
        }
        setTableChannels([]);
    }

    if (currentDevice === "CircularProgress") {
        const channelValue = document.getElementById("pvChannels").value;
        setProgressChannels(progressChannels.concat(channelValue));
        if (Object.keys(tempTabIndexCircularProgress).length > 0) {
            const particularDevice = tempTabIndexCircularProgress[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexCircularProgress[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? [channelValue] : previousChannels,
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page
                            let oldtabIndexProgressBar = [
                                ...tempTabIndexCircularProgress[activeTabIndex],
                            ];
                            const organizedDeviceIndex = oldtabIndexProgressBar.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            const newUpdatedData = {
                                ...oldtabIndexProgressBar[organizedDeviceIndex],
                                chartChannel: progressChannels
                                    ? [channelValue]
                                    : previousChannels,
                            };
                            oldtabIndexProgressBar[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexProgressBar,
                            };
                            setTempTabIndexCircularProgress(newTempTabIndexDevices);
                            setUpdatedTabIndexCircularProgress(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleCircularProgress.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleCircularProgress;
                const deviceToUpdate = multipleCircularProgress.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = [channelValue];
                setMultipleCircularProgress(updatedDeviceName);
            }
        }
    }



    if (currentDevice === "Doughnut") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexDoughnut).length > 0) {
            const particularDevice = tempTabIndexDoughnut[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexDoughnut[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? doughnutChannels : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);
                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexDoughnut[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    doughnutChannels.length > 0
                                        ? doughnutChannels
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexDoughnut(newTempTabIndexDevices);
                            setUpdatedTabIndexDoughnut(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleDoughnut.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleDoughnut;
                const deviceToUpdate = multipleDoughnut.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = doughnutChannels;
                setMultipleDoughnut(updatedDeviceName);
            }
        }
        setDoughnutChannels([]);
    }

    if (currentDevice === "Slider") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexSlider).length > 0) {
            const particularDevice = tempTabIndexSlider[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexSlider[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? [channelValue] : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);
                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexSlider[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    channelValue ?
                                        [channelValue]
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexSlider(newTempTabIndexDevices);
                            setUpdatedTabIndexSlider(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleSlider.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleSlider;
                const deviceToUpdate = multipleSlider.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = channelValue;
                setMultipleSlider(updatedDeviceName);
            }
        }
        setSliderChannels([]);
    }

    if (currentDevice === "Lamp") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexLamp).length > 0) {
            const particularDevice = tempTabIndexLamp[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexLamp[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? [channelValue] : previousChannels,
                                lampStatus: lampStatus
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);
                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexLamp[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    channelValue ?
                                        [channelValue]
                                        : previousChannels,
                                lampStatus: lampStatus
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexLamp(newTempTabIndexDevices);
                            setUpdatedTabIndexLamp(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleLamp.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleLamp;
                const deviceToUpdate = multipleLamp.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = [channelValue];
                deviceToUpdate.lampStatus = lampStatus;
                setMultipleLamp(updatedDeviceName);
            }
        }
    }


    if (currentDevice === "Switch") {
        const channelValue = document.getElementById("pvChannels").value;
        if (Object.keys(tempTabIndexSwitch).length > 0) {
            const particularDevice = tempTabIndexSwitch[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexSwitch[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousChannels =
                                temporaryWidgets[originalDeviceIndex]?.chartChannel;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel:
                                    channelValue !== null ? [channelValue] : previousChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;

                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);
                            // storing new channel name to display data in main page
                            let oldtabIndexChart = [...tempTabIndexSwitch[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexChart.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            const newUpdatedData = {
                                ...oldtabIndexChart[organizedDeviceIndex],
                                chartChannel:
                                    channelValue ?
                                        [channelValue]
                                        : previousChannels,
                            };

                            oldtabIndexChart[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexChart,
                            };
                            setTempTabIndexSwitch(newTempTabIndexDevices);
                            setUpdatedTabIndexSwitch(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleSwitch.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleSwitch;
                const deviceToUpdate = multipleSwitch.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = [channelValue];
                setMultipleSwitch(updatedDeviceName);
            }
        }
    }



    if (currentDevice === "Square") {
        const pvChannelValue = document.getElementById("pvChannels").value;

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );

        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexSquare).length > 0) {
            const particularDevice = tempTabIndexSquare[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexSquare[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;


                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexSquare[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexSquare(newTempTabIndexDevices);
                                setUpdatedTabIndexSquare(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multipleSquare.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleSquare];
                const deviceToUpdate = multipleSquare.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                setMultipleSquare(updatedDeviceName);
            }
        }
    }


    if (currentDevice === "Circle") {
        const pvChannelValue = document.getElementById("pvChannels").value;

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );

        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexCircle).length > 0) {
            const particularDevice = tempTabIndexCircle[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexCircle[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;


                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexCircle[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexCircle(newTempTabIndexDevices);
                                setUpdatedTabIndexCircle(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multipleCircle.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleCircle];
                const deviceToUpdate = multipleCircle.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                setMultipleCircle(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "Text") {
        const pvChannelValue = document.getElementById("pvChannels").value;

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );

        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexText).length > 0) {
            const particularDevice = tempTabIndexText[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexText[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;


                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexText[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexText(newTempTabIndexDevices);
                                setUpdatedTabIndexText(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multipleText.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleText];
                const deviceToUpdate = multipleText.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                setMultipleText(updatedDeviceName);
            }
        }
    }
    if (currentDevice === "Pipe") {
        const pvChannelValue = document.getElementById("pvChannels").value;

        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );

        setPVSpecificChannel(pvSpecificChannel.concat(pvChannelValue));
        if (Object.keys(tempTabIndexPipe).length > 0) {
            const particularDevice = tempTabIndexPipe[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexPipe[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousPV =
                                temporaryWidgets[originalDeviceIndex]?.channelName?.PV;


                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                channelName: {
                                    ...temporaryWidgets[originalDeviceIndex].channelName,
                                    PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                },
                            };

                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets)
                            // storing new channel name to display data in main page

                            let oldtabIndexDevices = [...tempTabIndexPipe[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexDevices.findIndex(
                                (data) => data.id === selectedDevice.id
                            );
                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexDevices[organizedDeviceIndex],
                                    channelName: {
                                        ...oldtabIndexDevices[organizedDeviceIndex].channelName,
                                        PV: pvChannelValue !== null ? pvChannelValue : previousPV,
                                    },
                                };

                                oldtabIndexDevices[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexDevices = {
                                    [activeTabIndex]: oldtabIndexDevices,
                                };
                                setTempTabIndexPipe(newTempTabIndexDevices);
                                setUpdatedTabIndexPipe(newTempTabIndexDevices);
                            }
                        }
                    }
                }
            }
        }

        if (multiplePipe.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multiplePipe];
                const deviceToUpdate = multiplePipe.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.pvChannel = pvChannelValue;
                setMultiplePipe(updatedDeviceName);
            }
        }
    }
};